import React, { useContext } from "react";
import { CartContext } from "../Component/CartContext";
import productData from "../Datas/productData";
import "../css/cartpage.scss";
import { Link, useNavigate } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";

const CartPage = () => {
  const navigate = useNavigate();
  const { cartItems, removeFromCart, updateQuantity } = useContext(CartContext);

  const getProductById = (id) => {
    return productData.find((product) => product.id === id);
  };

  const calculateTotal = () => {
    let total = 0;
    cartItems.forEach((item) => {
      const product = getProductById(item.id);
      if (product) {
        const price = parseFloat(product.price.replace(/,/g, ""));
        total += price * item.quantity;
      }
    });
    return total;
  };

  const subtotal = calculateTotal();

  const handleUpdateQuantity = (id, size, color, newQuantity) => {
    if (newQuantity > 0) {
      updateQuantity(id, size, color, newQuantity);
    }
  };

  const handleCheckout = () => {
    if (cartItems.length > 0) {
      navigate("/checkout");
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      alert("Your cart is empty");
    }
  };

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (cartItems.length === 0) {
    return (
      <div className="cart-page">
        <Header />

        <div className="cart-page__empty">
          <div className="cart-page__empty-box">
            <h2>Your cart is empty</h2>
            <p>Explore our collection of fine teas and ceramics!</p>

            <Link
              to="/shop"
              onClick={toTop}
              className="cart-page__continue-btn"
            >
              Continue shopping
            </Link>
          </div>
        </div>

        <Footer />
      </div>
    );
  }

  return (
    <div className="cart-page">
      <Header />

      <main className="cart-page__main">
        <div className="cart-page__left">
          <h2 className="cart-title">YOUR SHOPPING BAG</h2>

          <div className="cart-items">
            {cartItems.map((item) => {
              const product = getProductById(item.id);
              if (!product) return null;
              const linePrice = (Number(product.price) * item.quantity).toFixed(
                2
              );
              return (
                <div
                  className="cart-item"
                  key={`${item.id}-${item.size}-${item.color}`}
                >
                  <div className="cart-item__thumb">
                    <img src={product.image} alt={product.name} />
                  </div>
                  <div className="cart-item__info">
                    <div className="cart-item__name">{product.name}</div>
                    <div className="cart-item__meta">
                      <span>Color : {item.color}</span>
                      <span> | </span>
                      <span>Size : {item.size}</span>
                    </div>

                    <div className="cart-item__actions">
                      <button
                        className="cart-action"
                        onClick={() =>
                          removeFromCart(item.id, item.size, item.color)
                        }
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                  <div className="cart-item__price">
                    <div className="qty-controls">
                      <button
                        onClick={() =>
                          handleUpdateQuantity(
                            item.id,
                            item.size,
                            item.color,
                            item.quantity - 1
                          )
                        }
                      >
                        -
                      </button>
                      <span className="qty">{item.quantity}</span>
                      <button
                        onClick={() =>
                          handleUpdateQuantity(
                            item.id,
                            item.size,
                            item.color,
                            item.quantity + 1
                          )
                        }
                      >
                        +
                      </button>
                    </div>
                    <div className="line-total">
                      HK${Number(linePrice).toLocaleString("en-US")}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="cart-continue">
            <Link
              to="/shop"
              onClick={toTop}
              className="cart-page__continue-btn"
            >
              Continue shopping
            </Link>
          </div>
        </div>

        <aside className="cart-page__right">
          <div className="summary">
            <div className="summary-row">
              <span>Delivery cost</span>
              <span>HK$100.00</span>
            </div>

            <div className="summary-total">
              <div className="label">
                Total{" "}
                <small>(taxes, import duties and delivery included)</small>
              </div>
              <div className="amount">
                HK${(subtotal + 100).toLocaleString("en-US")}
              </div>
            </div>

            <button className="place-order" onClick={handleCheckout}>
              Place order
            </button>
          </div>
        </aside>
      </main>

      <Footer />
    </div>
  );
};

export default CartPage;
